import * as Sentry from "@sentry/browser";

import {getAppInfo} from "@client/hardware";

export const init = async (dsn: string, user?: {email: string} | null) => {
    Sentry.init({
        release: process.env.RELEASE_VERSION,
        dsn,
        normalizeDepth: 10,

        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0,
        integrations: [
            Sentry.replayIntegration({
                // Numberflow
                block: [".number__inner"],
                maskAllText: false,
                maskAllInputs: false,
                blockAllMedia: false,
            }),
            Sentry.replayCanvasIntegration(),
        ],
    });

    const {appVersion, platform, build, version} = await getAppInfo();

    Sentry.setTag("appVersion", appVersion);
    Sentry.setTag("version", version);
    Sentry.setTag("platform", platform);
    Sentry.setTag("build", build.toString());

    if (user != null) {
        Sentry.setUser({
            email: user.email,
        });
    }
};
